module.exports = __webpack_public_path__ + "static/img/bg-fr.39db562c.webp";